import { EventScheduleApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useUpdatePublished() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventScheduleApi.patchPublished, {
    onSuccess: (response, variables) => {
      queryClient.setQueryData(
        getQueryKeys([KEY]).detail(variables.eventId),
        response,
      );
    },
  });
}

export default useUpdatePublished;
